import * as actionTypes from '../actions/actionTypes';
import {success} from '../actions/makeAction';
const DEFAULT_STATE = {
  foundBlocks: {
    results: [],
  },
  loading: false,
};

const reducer = (state=DEFAULT_STATE, action) => {
  switch (action.type) {
    case success(actionTypes.FETCH_FOUND_BLOCKS):
      return {
        ...state,
        foundBlocks: action.payload,
        loading: false,
      };
    case '@@router/LOCATION_CHANGE':
      return {
        ...DEFAULT_STATE,
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// /src/redux/reducers/blocksReducer.js